import * as types from '../constants/ActionTypes';
import initialState from './initialState';

export default function(state = initialState.pedido, action) {
  switch (action.type) {
    case types.SET_PEDIDO:
      return {
        ...state,
        ...action.payload.pedido,
      };

    case types.REINICIAR:
      return initialState.pedido;

    case types.REINICIAR_PEDIDO:
      return initialState.pedido;

    default:
      return state;
  }
}
